<!--suppress CssUnusedSymbol -->
<template>
  <div class="flex items-center">
    <div
      v-for="(step, i) in steps"
      :key="i"
      :class="{ active: current === i + 1, done: current > i + 1 }"
      class="step"
    >
      <div class="step-index">
        <i v-if="current > i + 1" class="pi pi-check"></i>
        <span v-else>{{ i + 1 }}</span>
      </div>
      <div class="step-label">{{ step }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Number,
      default: 1
    },
    steps: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      current: this.active
    }
  },
  methods: {
    //
  }
}
</script>

<style scoped>
.step {
  @apply flex items-center mr-4;
}

@screen xl {
  .step {
    @apply mr-20;
  }
}

.step:last-child {
  @apply mr-0;
}

.step.active .step-index {
  @apply bg-blue-500 text-white;
}

.step.active .step-label {
  @apply text-gray-600 hidden;
}

@screen md {
  .step.active .step-label {
    @apply block text-gray-900;
  }
}

.step.done .step-index {
  @apply bg-blue-500 text-white;
}

.step.done .step-label {
  @apply text-gray-600 hidden;
}

@screen md {
  .step.done .step-label {
    @apply block text-gray-900;
  }
}

.step-index {
  @apply w-8 h-8 rounded-full bg-white flex items-center justify-center text-gray-400 font-semibold shadow-lg;
}

@screen sm {
  .step-index {
    @apply w-10 h-10;
  }
}

.step-label {
  @apply hidden ml-4 text-gray-400 font-semibold;
}

@screen lg {
  .step-label {
    @apply block;
  }
}
</style>
